import Card from 'components/Card';
import CardContent from 'components/CardContent';
import styles from './PayableDetail.module.scss';
import ButtonWithIcon from 'components/ButtonWithIcon';
import classNames from 'classnames';
import {Prescription} from 'types';
import {BanknoteIcon} from '../icons/banknote';
import {useMemo} from 'react';
import {formatPrice} from 'utils/format-price';

interface Props {
  drugs: Prescription[];
  status?: string;
  onChargeManually: () => void;
}

function PayableDetail({drugs, status, onChargeManually}: Props) {
  const paymentDetail = useMemo(() => {
    const obj = {
      total_amount: 0,
      total_paid: 0,
      amount_due: 0,
    };
    drugs?.forEach((curr: Prescription) => {
      obj.total_amount += Number(curr.payable_total_amount || 0);
      obj.total_paid += Number(curr.payable_paid || 0);
      obj.amount_due += Number(curr.payable_amount_due || 0);
    });
    return obj;
  }, [drugs]);

  const isDisabled = useMemo(() => {
    return (
      drugs?.filter((item) => Number(item.payable_amount_due) > 0).length ===
        0 ||
      (status === 'completed'
        ? drugs?.filter((item) => item.status !== 'completed').length === 0
        : false)
    );
  }, [drugs, status]);

  return (
    <>
      <Card className={styles.card}>
        <CardContent pt="md" pb="sm">
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>Money Out</h2>
          </div>
          <div className={styles.paymentGrid}>
            <div className={styles.paymentItem}>
              <div className={styles.paymentLabel}>Total amount</div>
              <div
                className={classNames(styles.paymentValue, styles.totalAmount)}
              >
                {formatPrice(paymentDetail.total_amount)}
              </div>
            </div>

            <div className={styles.paymentItem}>
              <div className={styles.paymentLabel}>Total paid</div>
              <div
                className={classNames(styles.paymentValue, styles.totalPaid)}
              >
                {formatPrice(paymentDetail.total_paid)}
              </div>
            </div>

            <div className={styles.paymentItem}>
              <div className={styles.paymentLabel}>Amount due</div>
              <div
                className={classNames(styles.paymentValue, styles.amountDue)}
              >
                {formatPrice(paymentDetail.amount_due)}
              </div>
            </div>
          </div>

          <div className={styles.row}>
            <ButtonWithIcon
              size="lg"
              disabled={isDisabled}
              color="ghost"
              onClick={onChargeManually}
              className={styles.notify_action}
              icon={<BanknoteIcon width={16} height={16} />}
            >
              Manual Charge
            </ButtonWithIcon>
          </div>
        </CardContent>
      </Card>
    </>
  );
}
export default PayableDetail;
